<template>
  <div class="my_text_biu_layer">
    <p :class="type == 'one_level' ? 'set_one_level': 'set_two_level'">
      <span v-text="title" class="title" :style="{
      width: titleWidth+ 'px'
     }"></span>
      <span class="text_biu_content">
        <i class="icon bold" :class="fs_weight == 'bold' ? 'active': ''" @click="clickText(fs_weight == 'bold' ? 'normal': 'bold','fs_weight')"></i>
        <i class="icon italics" :class="fs_italics == 'oblique' ? 'active': ''" @click="clickText(fs_italics == 'oblique' ? 'normal': 'oblique','fs_italics')"></i>
        <i class="icon underline" :class="fs_underline == 'underline' ? 'active': ''" @click="clickText(fs_underline == 'underline' ? 'none': 'underline','fs_underline')"></i>
      </span>
    </p>
  </div>
</template>

<script>
  export default {
    name:'my_text_biu_index',
    props:{
      titleWidth: { // 组件的标题
        type:String,
        default: '40'
      },
      title: { // 组件的标题
        type:String,
        default: ''
      },
      type: { // 组件的类型  one_level 一级组件 two_level 二级组件
        type:String,
        default: 'two_level'
      },
      fsWeight: { // 粗体
        type:String,
        default: 'normal'
      },
      fsItalics: { // 斜体
        type:String,
        default: 'normal'
      },
      fsUnderline: { // 下划线
        type:String,
        default: 'none'
      }
    },
    data(){
      return {
        fs_weight:this.fsWeight,
        fs_italics:this.fsItalics,
        fs_underline:this.fsUnderline,
        text_align:this.textAlign,
        textAlignDialogIsShow: false
      }
    },
    mounted() {
    },
    watch:{
      fs_weight(val){
        this.$emit('update:fsWeight',val);//双向数据绑定
      },
      fs_italics(val){
        this.$emit('update:fsItalics',val);//双向数据绑定
      },
      fs_underline(val){
        this.$emit('update:fsUnderline',val);//双向数据绑定
      },
      'fsWeight'(val){
        this.fs_weight = val
      },
      'fsItalics'(val){
        this.fs_italics = val
      },
      'fsUnderline'(val){
        this.fs_underline = val
      }
    },
    computed:{
    },
    methods:{
      clickText(value,key) {
        this[key] = value
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/my_text_biu/index.vue